'use client';
import JDIProductCardV2 from '@/components/productCard/components/type1/index';

export default function Product({ product, index }: any) {
  const genEventTrackingInfo = (product: any, index: number) => {
    const spmTrackParams = {} as { [key: string]: any };
    const json_param = { skuid: product.skuId, index: index };
    const expConfig = {
      useClick: false,
      stay_duration: 0,
      repeated: false,
      area_rate: 0.01,
    };
    spmTrackParams['productClick'] = {
      spm: `a0145.b002218.c00002479.${index + 1}`,
      page_id: 'Home_Main',
      event_id: 'Home_Pro_FlashSales',
      json_param: json_param,
    };
    spmTrackParams['productExpConfig'] = {
      spm: `a0145.b002218.c00002479.${index + 1}`,
      page_id: 'Home_Main',
      event_id: 'Home_Pro_FlashSales_Expo',
      config: expConfig,
      json_param: json_param,
    };
    return spmTrackParams;
  };

  const productConfig = {
    ...product,
    spmTrackParams: genEventTrackingInfo(product, index),
    priority: index < 4,
  };

  return <JDIProductCardV2 productData={productConfig} key={product.skuId} />;
}
